var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"maps",staticClass:"my-map",attrs:{"id":"my-map"}},[_c('div',{staticClass:"fly",on:{"click":_vm.goFly}})])}
var staticRenderFns = []

export { render, staticRenderFns }